import React from "react";
import ChargeWaiverMaintenance from "./ChargeWaiverMaintenance";

export const ChargeWaiverMDView: React.FC = () => {

    return <>
        {<div className="main-comp-wrapper" >
            <ChargeWaiverMaintenance />
        </div>}
    </>
}
